var _style, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIntegration = function SvgIntegration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.8 16.2",
    style: {
      enableBackground: "new 0 0 21.8 16.2"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#698DB0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.8,5.2L17.8,5.2L17.8,5.2c-0.3-1.4-1-2.6-2-3.6C14.6,0.6,13.1,0,11.5,0C10.3,0,9.1,0.4,8,1 c-0.8,0.5-1.5,1.2-2,2l0,0.1L6,3.1c-0.2,0-0.4,0-0.5,0c-2,0-3.5,1.6-3.5,3.5c0,0.2,0,0.4,0,0.6l0,0.1l0,0C0.7,8.2,0,9.7,0,11.2 c0,1.3,0.5,2.5,1.3,3.4c0.9,1,2,1.6,3.3,1.6h0.9l11.9,0c0,0,0.3,0,0.6,0c1.1-0.2,1.9-0.8,2.7-1.7c1-1.1,1-2.5,1-3.8 C21.8,8.2,20.1,5.9,17.8,5.2z M18.2,14.7L18.2,14.7c0,0-0.1,0-0.3,0.1l-0.1,0c-0.4,0.1-0.7,0.1-0.7,0.1c0,0,0,0,0,0L4.7,14.8 c-1.8-0.1-3.2-1.8-3.2-3.7c0-1.2,0.7-2.3,1.7-3C3.4,8,3.6,7.6,3.4,7.3C3.4,7.1,3.3,6.9,3.3,6.6c0-1.2,0.9-2.1,2.1-2.1 c0.2,0,0.5,0,0.7,0.1c0.4,0.1,0.7,0,0.9-0.4c0.8-1.7,2.6-2.8,4.5-2.8c2.6,0,4.7,1.9,4.9,4.5c0,0.3,0.3,0.6,0.6,0.6 c1.9,0.3,3.4,2.1,3.4,4.1C20.4,12.8,19.6,14.2,18.2,14.7z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIntegration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/integration.d9d7f36f.svg";
export { ForwardRef as ReactComponent };